export default __webpack_public_path__ + "static/media/rephrase-icon.f5e3bc21.svg";